import type { DashboardPDFOverlayData } from './useDashboardPDFOverlayData.types';
import type { DashboardPDFOverlayHandlers } from './useDashboardPDFOverlayHandlers.types';

import * as pdfObject from 'pdfobject';
import * as constants from '../DashboardPDFOverlay.constants';

import { useRightPanelReduxActions } from 'shared/features/rightPanel/hooks';
import { useCallback } from 'react';

export const useDashboardPDFOverlayHandlers = ({
  reduxState
}: {
  reduxState: DashboardPDFOverlayData['reduxState'];
}): DashboardPDFOverlayHandlers => {
  const rightPanelReduxActions = useRightPanelReduxActions();

  const handlePDFLoad: DashboardPDFOverlayHandlers['handlePDFLoad'] = useCallback(() => {
    pdfObject.embed(reduxState.documentPDFUrl, constants.DASHBOARD_PDF_OVERLAY);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reduxState.documentPDFUrl, reduxState.overlayRefreshTrigger]);

  const handleOverlayClose: DashboardPDFOverlayHandlers['handleOverlayClose'] = () => {
    rightPanelReduxActions.toggleShouldReopenOverlay(false);
    if (reduxState.shouldCloseRightPanelOnOverlayClose) {
      rightPanelReduxActions.closeRightPanel();
    } else {
      rightPanelReduxActions.closeOverlay();
    }
  };

  return {
    handlePDFLoad,
    handleOverlayClose
  };
};
